import Vue from "vue";

export const ModalBus = new Vue();
